import { createPortal } from 'react-dom';

interface PortalProps {
  children: React.ReactNode;
  target?: HTMLElement | null;
}

const Portal = ({ children, target }: PortalProps) => {
  const el = target ?? document.getElementById('portal-root');
  if (!el) return null;
  return createPortal(children, el);
};

export default Portal;
